export class SeededRandom {
  private seed: number;

  constructor(seed: number) {
    this.seed = seed;
  }

  // Linear congruential generator (Park and Miller)
  next(): number {
    this.seed = (this.seed * 16807) % 2147483647;
    return (this.seed - 1) / 2147483646;
  }

  // Random float between min and max
  range(min: number, max: number): number {
    return min + this.next() * (max - min);
  }

  // Random integer between min and max (inclusive)
  intRange(min: number, max: number): number {
    return Math.floor(this.range(min, max + 1));
  }

  // Random boolean with given probability
  boolean(probability: number = 0.5): boolean {
    return this.next() < probability;
  }

  // Random element from array
  choose<T>(array: T[]): T {
    return array[this.intRange(0, array.length - 1)];
  }
}